import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exportClientFitCandidateArtifacts } from "@/app/api/client-fit";
import { SCREENINGS_QUERY_KEYS } from "@/hooks/queries/screenings.queries";

export const useClientFitCandidateArtifactExportMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: exportClientFitCandidateArtifacts,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: SCREENINGS_QUERY_KEYS.base });
    },
  });
};
